import type {
  ChanelActionType,
  IncomingMessagePayload,
  IWebSocketConnection,
  PositionWSUpdate,
  RepositoryWS
} from '../../index'
import { PrivateConnectionChannels, WebSocketConnectionManager } from "../../index";

export class PositionApiWS implements RepositoryWS<PositionWSUpdate> {
  private wsChannel = PrivateConnectionChannels['POSITION']

  constructor(private wsManager: WebSocketConnectionManager) {
  }

  async subscribeToChannelsAction(
    actionName: ChanelActionType,
    cb: (position: PositionWSUpdate) => void
  ): Promise<undefined | ReturnType<IWebSocketConnection['subscribeToChannelMessages']>> {
    const connection = await this.wsManager.getConnection('private')
    const unsubscribeChannel = connection.subscribeToChannelMessages(this.wsChannel)
    const unsubscribeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<PositionWSUpdate>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })

    this.unsubscribeChannel = unsubscribeChannel
    this.unsubscribeHandler = unsubscribeHandler

    return () => {
      unsubscribeHandler()
      unsubscribeChannel()
    }
  }

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }

  private unsubscribeHandler: (() => void) = () => {
    throw new Error("Method not initialized.");
  }

  private unsubscribeChannel: (() => void) = () => {
    throw new Error("Method not initialized.");
  }
}
